// extracted by mini-css-extract-plugin
export default {"table":"ListPropertyAdvancedRatesPage_table__F2heB","boxBadge":"ListPropertyAdvancedRatesPage_boxBadge__EhkaN"};